<!-- SearchBar.vue -->
<template>
  <form @submit.prevent="search">
    <div class="search-box">
      <input class="search-input" v-model="searchQuery" placeholder="Pesquisar..." type="text" />
      <button type="submit" class="search-button">
        <font-awesome-icon :icon="['fas', 'search']" :style="{ color: '#fff', width: '24px', height: '22px' }" />
      </button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: ""
    };
  },
  methods: {
    search() {
      this.$router.push({ name: "results", query: { tag: this.searchQuery } });
    }
  }
};
</script>

<style scoped>
.search-box {
  display: flex;
  padding: 6px;
  border-radius: 25px;
  border: 1px solid #ccc;
  width: 270px;
  margin-right: 8px;
  margin-left: 5px;
  position: relative;
  background: rgba(231, 234, 237, 0.1);
  height: 51px;
}

.search-button {
  position: absolute;
  right: 15px;
  bottom: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.search-input {
  color: #fff;
  width: 80%;
  background: transparent;
  border: none;
  outline: none;
  padding-left: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: regular;
  font-size: 12px;
}

.search-input::placeholder {
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-weight: regular;
  font-size: 12px;
}

@media (max-width: 768px) {
  .search-box {
    width: 185px;
    padding: 5px;
    margin-right: 12px;
    margin-left: 2px;
    border-radius: 20px;
    height: 35px;
  }
  
  .search-input {
    font-size: 10px;
    padding-left: 6px;
    width: 75%;
  }
  
  .search-input::placeholder {
    font-size: 10px;
  }

  .search-button {
    right: 20px;
    top: 5px;
  }
}
</style>
